module.exports = __webpack_public_path__ + "static/media/WCM_MB_LOGO_HZSS2L_CLR_RGB.68e0781e.png";